// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__+K0gE","polaroid":"Gallery_polaroid__b5xwl","left":"Gallery_left__4gSSt","right":"Gallery_right__snrHO","center":"Gallery_center__t1yXv"};